import { IAppState } from '../../redux';
import { selectPlacingMoneySource } from '../publishTerms';
import { EMoneySource } from '../../redux/reducers';

export const selectIsMasterMoneySource = (state: IAppState): boolean => {
  const {
    user: { isSubAgent },
  } = state;

  const placingMoneySource = selectPlacingMoneySource(state);

  return isSubAgent && placingMoneySource === EMoneySource.Master;
};
